/*
 * @Author: tao_yang
 * @Date: 2022-11-17 14:57:11
 * @LastEditors: tao_yang
 * @LastEditTime: 2022-12-22 17:03:38
 * @Description: 落地页 关于福昕组件
 */
import './AboutFoxit.scss';

export default function AboutFoxit(props) {
    const ORGANIZE_LIST = [
        {
            img: require('@/assets/img/landing/Image_1.png').default,
            title: intl.get('landingPage.aboutFoxit.message1'),
            subTitle: intl.get('landingPage.aboutFoxit.message2'),
        },
        {
            type: 'line',
        },
        {
            img: require('@/assets/img/landing/Image2.png').default,
            title: intl.get('landingPage.aboutFoxit.message3'),
            subTitle: intl.get('landingPage.aboutFoxit.message4'),
        },
        {
            type: 'line',
        },
        {
            img: require('@/assets/img/landing/Image_3.png').default,
            title: intl.get('landingPage.aboutFoxit.message5'),
            subTitle: intl.get('landingPage.aboutFoxit.message6'),
        },
    ];

    const PRODUCTION_LIST = [
        {
            title: intl.get('landingPage.intelligentDesign.production1'),
            description: intl.get(
                'landingPage.intelligentDesign.productionDesc2'
            ),
            img: require('&/assets/img/padLanding/productionBG1.png').default,
            url: '/landing/IntelligentDesign',
        },
        {
            title: intl.get('landingPage.intelligentDesign.production2'),
            description: intl.get(
                'landingPage.intelligentDesign.productionDesc1'
            ),
            img: require('&/assets/img/padLanding/productionBG2.png').default,
            url: `/landing/IntelligentDesignPad`,
        },
        {
            title: intl.get('landingPage.intelligentDesign.production3'),
            description: intl.get(
                'landingPage.intelligentDesign.productionDesc3'
            ),
            img: require('&/assets/img/padLanding/productionBG3.png').default,
            url: '/landing/index',
        },
        {
            title: intl.get('landingPage.intelligentDesign.production4'),
            description: intl.get(
                'landingPage.intelligentDesign.productionDesc4'
            ),
            img: require('&/assets/img/padLanding/productionBG4.png').default,
            url: '/b/landing/index',
        },
    ];

    return (
        <div className={`about-foxit-desc ${props.isHDC ? 'hdc-about' : ''}`}>
            <div className="about__title max-width-wrap">
                {intl.get('landingPage.aboutFoxit.message7')}
            </div>
            <div className="content max-width-wrap">
                {intl.get('landingPage.aboutFoxit.message8')}
                <span>7.5</span>
                {intl.get('landingPage.aboutFoxit.message9')}
                <span>42.5</span>
                {intl.get('landingPage.aboutFoxit.message10')}
                <span>200</span>
                {intl.get('landingPage.aboutFoxit.message11')}
            </div>
            <div className="organize-container max-width-wrap">
                {ORGANIZE_LIST.map((v, index) => {
                    if (v.type === 'line') {
                        return <div className="line" key={index}></div>;
                    } else {
                        return (
                            <div className="organize-wrap" key={index}>
                                <div className="desc-wrap">
                                    <div className="organize-title">
                                        <img src={v.img}></img>
                                        {v.title}
                                    </div>
                                    <div className="subTitle">{v.subTitle}</div>
                                </div>
                            </div>
                        );
                    }
                })}
            </div>
            {props.middle}
            <div className="producntion-list max-width-wrap">
                <div className="about__title">
                    {intl.get('landingPage.message18')}
                </div>
                <div className="production-card-list">
                    {PRODUCTION_LIST.map((production, index) => (
                        <div
                            className="production-card"
                            key={index}
                            onClick={() => window.open(production.url)}
                        >
                            <img
                                className="background-image"
                                src={production.img}
                            />
                            <div className="production-card-title">
                                {production.title}
                            </div>
                            <div className="production-card-content">
                                {production.description}
                            </div>
                            <div className="view-detail">
                                {intl.get('base.viewDetail')}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
